import React from 'react';
import SalesLetterWrapper from './SalesLetterWrapper';
import SafeIcon from '../common/SafeIcon';
import { FiAnchor } from 'react-icons/fi';

const ThePeterLetter = () => {
  return (
    <SalesLetterWrapper alt={true} className="border-y border-slate-200">
      <div className="space-y-8 font-serif">
        <div className="flex items-center gap-4 mb-12">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/40a492dc43bc618e18a36c285588ccb1d2fe8075e2c19e16c3546447a7641f452c8a03ca0e53bb9227c01b726e9832ee/images/aW1hZ2UvanBlZw==/8ac32adbd32e017f2f332a50aad60f67.jpeg" 
            alt="Peter" 
            className="w-20 h-20 rounded-full border-4 border-white shadow-lg object-cover object-top"
          />
          <div>
            <h2 className="text-3xl font-display font-black text-brand-dark m-0">Meet Peter</h2>
            <p className="text-sm font-bold text-brand-gold uppercase tracking-widest">Firefighter preparing for retirement</p>
          </div>
        </div>

        <div className="space-y-6 text-xl leading-relaxed text-text-primary/90">
          <p>After 32 years working as a firefighter, Peter began thinking seriously about retirement. Not just financially… But emotionally too.</p>
          
          <p>Because retirement isn’t only about money, superannuation, or savings. <span className="font-bold border-b-2 border-brand-gold pb-1">It’s also about: purpose.</span></p>

          <p>Peter didn’t want retirement to feel: financially restrictive, stressful, or empty. He wanted: flexibility, meaningful work, supplemental income, and freedom.</p>

          <p>Like many retirees exploring online income, Peter quickly discovered the internet was full of: complicated business models, risky strategies, expensive systems, and unrealistic promises.</p>

          <p>He explored: ecommerce, Amazon FBA, SaaS, digital marketing, and many other online business models.</p>

          <p className="text-2xl font-bold text-brand-dark italic">And while some worked… Peter eventually discovered something surprising:</p>

          <div className="bg-white p-8 md:p-12 rounded-[2.5rem] shadow-premium border-l-8 border-brand-dark font-display">
            <p className="text-2xl md:text-3xl font-black mb-6">"The simplest models were often the best ones."</p>
            <div className="grid grid-cols-2 gap-4 text-lg font-bold text-brand-gold">
              <p>• Less stress.</p>
              <p>• Less complication.</p>
              <p>• Less risk.</p>
              <p>• More flexibility.</p>
              <p>• More enjoyment.</p>
            </div>
          </div>

          <p>That realization changed everything. Over time, Peter built successful online income streams focused on simplicity, flexibility, and practical online opportunities.</p>

          <p>In fact… This very book is now part of Peter’s own supplemental online income strategy as he prepares for the next chapter.</p>

          <p className="text-2xl font-display font-black text-brand-dark pt-6">
            And now he’s sharing the lessons that helped him create: <span className="text-brand-green underline decoration-brand-green/20 underline-offset-8">more freedom, more purpose, and more financial breathing room in preparation for his retirement.</span>
          </p>
        </div>
      </div>
    </SalesLetterWrapper>
  );
};

export default ThePeterLetter;